import { render, staticRenderFns } from "./AssistantOrderCard.vue?vue&type=template&id=06cf8e5a&scoped=true"
import script from "./AssistantOrderCard.vue?vue&type=script&lang=js"
export * from "./AssistantOrderCard.vue?vue&type=script&lang=js"
import style0 from "./AssistantOrderCard.vue?vue&type=style&index=0&id=06cf8e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cf8e5a",
  null
  
)

export default component.exports